<div class="input-container" [class]="containerClass">
	<div class="container-label-input">
		<label *ngIf="label" [for]="uniqueId" class="input-label">{{ label }}</label>

		<ng-container [ngSwitch]="type">
			<div class="input-wrapper" [class.has-error]="isInvalid">

        <!-- Checkbox input -->
				<ng-container *ngSwitchCase="InputTypeEnum.Checkbox">
					<input
						*ngIf="type === 'checkbox'"
						[id]="uniqueId"
						type="checkbox"
						[readonly]="readonly"
						[disabled]="disabled"
						[checked]="value"
						(change)="onCheckboxChange($event)"
						(blur)="onBlur()"
						class="custom-checkbox-input"
					/>
				</ng-container>

        <!-- Text Area input -->
				<ng-container *ngSwitchCase="InputTypeEnum.TextArea">
					<textarea
						*ngIf="type === 'textArea'"
						[id]="uniqueId"
						[placeholder]="placeholder"
						[readonly]="readonly"
						[disabled]="disabled"
						[value]="value"
						[rows]="rows"
						[cols]="cols"
						(input)="onInput($event)"
						(blur)="onBlur()"
						class="custom-textarea"
					></textarea>
				</ng-container>

        <!-- Phone input -->
				<ng-container *ngSwitchCase="InputTypeEnum.Phone">
					<input
						class="custom-input"
						[id]="uniqueId"
						type="tel"
						[appPhoneMask]="true"
						[placeholder]="placeholder"
						[value]="value"
						[readonly]="readonly"
						(phoneValueChange)="onPhoneValueChange($event)"
						(blur)="onBlur()"
					/>
				</ng-container>

        <!-- Dropdown input -->
				<ng-container *ngSwitchCase="InputTypeEnum.Dropdown">
					<select
						*ngIf="type === 'dropdown'"
						[id]="uniqueId"
						[disabled]="disabled"
						[value]="value"
						(change)="onDropdownChange($event)"
						(blur)="onBlur()"
						class="custom-input custom-select"
					>
						<option *ngIf="placeholder" value="" disabled selected hidden>{{ placeholder }}</option>
						<option *ngFor="let option of options" [value]="optionValue ? getOptionProperty(option, optionValue) : option">
							{{ optionLabel ? getOptionProperty(option, optionLabel) : option }}
						</option>
					</select>
				</ng-container>

        <!-- Standard inputs -->
				<ng-container *ngSwitchDefault>
					<div *ngIf="customIcon" class="custom-icon-container">
						<app-icon [iconName]="customIcon"></app-icon>
					</div>

					<input
						*ngIf="['text', 'password', 'email', 'phone', 'number', 'search'].includes(type)"
						class="custom-input"
						[id]="uniqueId"
						[type]="type == 'password' && showPassword ? 'text' : type"
						[placeholder]="placeholder"
						[value]="value"
						[readonly]="readonly"
						[disabled]="disabled"
						(input)="onInput($event)"
						(blur)="onBlur()"
					/>
				</ng-container>

				<div *ngIf="type === 'password'" class="password-toggle" (click)="togglePassword()">
					<app-icon [iconName]="showPassword ? 'eye' : 'eye-off'"></app-icon>
				</div>
			</div>
		</ng-container>

		<div class="error-container" *ngIf="isInvalid && getErrorMessage()">
			<small class="error-message">{{ getErrorMessage() }}</small>
		</div>
	</div>
</div>
